import React, { useState, useEffect } from "react";
import { Multiselect } from "./common/Multiselect";
import { getList, getDrugList } from "../services/dashApiService";
import { QuestionnaireHeader } from "./QuestionnaireHeader";
import { QuestionnaireFooter } from "./QuestionnaireFooter";

const apiCalls = {
	getList,
	getDrugList,
};

export const QuestionnaireSelectMultiplePage = ({
	def,
	onRespond,
	currentResponse,
}) => {
	const [values, setValues] = useState([]);
	const [options, setOptions] = useState();
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		const opts = [];

		if (options) {
			return;
		}

		if (def.options) {
			for (const o of def.options) {
				if (o.default) {
					opts.push(o.value);
				}
			}
		}

		setOptions(opts);

		if (!currentResponse) {
			const response = {};
			response.id = def.id;
			response.value = opts;

			onRespond(response);
		}
	}, [def, currentResponse, onRespond, options]);

	useEffect(() => {
		let values;

		if (currentResponse && currentResponse.value) {
			values = currentResponse.value;
		} else if (def.answer && def.answer.length) {
			values = Array.isArray(def.answer)
				? def.answer
				: !def.answer
				? []
				: [def.answer];

			const response = {};
			response.id = def.id;
			response.value = values;

			onRespond(response);
		} else {
			values = def.defaultOptions || [];
		}

		setValues(values);
	}, [currentResponse, def, onRespond]);

	useEffect(() => {
		const data = { ...def.params };
		const api = apiCalls[def.api || "getList"];

		api(data)
			.then((result) => {
				const options = [];
				for (const d of result.data.list) {
					options.push({ value: d.value, display: d.display });
				}

				setOptions(options);
				setIsLoading(false);
			})
			.catch(() => {
				setIsLoading(false);
			});
	}, [def]);

	const onChange = (e) => {
		const value = e.value;

		// sort the values
		const sort = (a, b) => {
			const aval = a.display;
			const bval = b.display;
			let ret = 0;

			if (aval < bval) {
				ret = -1;
			} else if (aval > bval) {
				ret = 1;
			}

			return ret;
		};

		if (value) {
			value.sort(sort);
		}

		const response = {};
		response.id = def.id;
		response.value = value;

		onRespond(response);
	};

	return (
		<>
			<QuestionnaireHeader def={def} />

			<Multiselect
				onChange={onChange}
				options={options}
				value={values}
				classes=""
				disabled={false}
				placeholder={def.placeholder}
				loading={isLoading}
				textField={def.textField}
				dataItemKey={def.dataItemKey}
				allowCustom={def.allowCustom}
			/>

			<QuestionnaireFooter def={def} />
		</>
	);
};
